export enum TicketQueueEnum {
    MODULE_ACCESS = 'View'
}